// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"571":"stencil-polyfills-dom","952":"stencil-polyfills-css-shim"}[chunkId] || chunkId) + "." + {"55":"2f15a156","76":"c9c0262d","133":"94b630e6","157":"fad4e3b0","571":"d6681f30","826":"d5c2a0ca","868":"9d04e3b3","908":"d98a786d","952":"fd3d4491"}[chunkId] + ".chunk.js";
};